import CMSProduct from "./cms/CMSProduct";
import ShopifyProduct from "./shopify/ShopifyProduct";
import ShopifyVariant from "./shopify/ShopifyVariant";
import ProductVariant from "./ProductVariant";
import ProductType from "./cms/ProductType";
import { SUBSCRIPTION_TYPES } from "@/utils/shopify";

export default class Product {
  id: string = "";
  title: string = "";
  availableForSale: boolean = false;
  displayTitle: string = "";
  reviewCategory: string = "";
  handle: string = "";
  images: string[] = [];
  lifestyleImages: string[] = [];
  shortDescription: string = "";
  longDescription: string = "";
  tags: string[] = [];
  badge: string = "";
  topBadge: string = "";
  variants: ProductVariant[] = [];
  price: number = 0;
  displayImgIndex: number = 0;
  hoverImgIndex: number = 0;
  productLine: string = "";
  priceText?: string;
  productType?: ProductType;
  useAltPriceText?: boolean = false;
  sellingPlanGroups: any[] = [];
  sellingPlans: any[] = [];
  bottomBanner?: string;
  bottomBannerMobile?: string;
  hereUntilText?: string;
  startDate?: string;
  rating: number = -1;
  endDate?: string;
  preselectedVariant?: string;
  productReviews?: object[];
  itemPrice?: string; // For calliaui ProductTileV2 - original/compare price for strikethrough
  itemSalesPrice?: string; // For calliaui ProductTileV2 - sale price

  constructor(shopifyProduct: ShopifyProduct, cmsProducts: any) {
    let filteredResult: CMSProduct;
    if (cmsProducts?.length > 0) {
      //constructor for when you have a list of possible products from CMS
      filteredResult = cmsProducts
        ?.map((product: any) => {
          return new CMSProduct(product);
        })
        .find((product: CMSProduct) => product.title == shopifyProduct?.title);
      if (!filteredResult) return;
    } else {
      //constructor for when you only have one product from CMS
      filteredResult = cmsProducts;
      if (filteredResult?.title !== shopifyProduct.title) return;
    }
    const variants = shopifyProduct.productVariants.map(
      (variant: ShopifyVariant) => {
        return new ProductVariant(
          variant,
          shopifyProduct.tags,
          filteredResult?.productType,
          filteredResult?.variantSalesPriceText
        );
      }
    );

    this.id = shopifyProduct.id ?? "";
    this.title = filteredResult?.title;
    this.availableForSale = shopifyProduct?.availableForSale;
    this.displayTitle = filteredResult?.displayTitle;
    this.reviewCategory = filteredResult?.reviewCategory;
    this.handle = shopifyProduct.handle ?? "";
    this.images = filteredResult?.images;
    this.lifestyleImages = filteredResult?.lifestyleImages;
    this.shortDescription = filteredResult?.shortDescription;
    this.longDescription = filteredResult?.longDescription;
    this.tags = shopifyProduct.tags;
    this.badge = filteredResult?.badge;
    this.topBadge = filteredResult?.topBadge;
    this.variants = variants;
    this.price = variants.length > 0 ? variants[0].price : 0;
    this.displayImgIndex = filteredResult?.displayImgIndex;
    this.hoverImgIndex = filteredResult?.hoverImgIndex;
    this.productLine = filteredResult?.productLine;
    this.priceText = filteredResult?.priceText;
    this.productType = filteredResult?.productType;
    this.sellingPlanGroups = shopifyProduct.sellingPlanGroups;
    this.bottomBanner = filteredResult?.bottomBanner;
    this.bottomBannerMobile = filteredResult?.bottomBannerMobile;
    this.hereUntilText = filteredResult?.hereUntilText;
    this.rating = filteredResult?.rating;
    this.preselectedVariant = filteredResult?.preselectedVariant;
    this.productReviews = filteredResult?.productReviews;

    this.startDate = filteredResult?.startDate;
    this.endDate = filteredResult?.endDate;

    if (this.sellingPlanGroups && this.sellingPlanGroups.length > 0) {
      this.sellingPlans = this.sellingPlanGroups[0].SellingPlans;
    }

    if (
      SUBSCRIPTION_TYPES.includes(this.productType.key) &&
      variants.length > 0
    ) {
      const minPrice = variants[0].price ?? 0;
      const maxPrice = variants[variants.length - 1].price ?? 0;

      if (filteredResult?.priceText?.includes("MIN_PRICE")) {
        this.priceText = filteredResult?.priceText.replace(
          "MIN_PRICE",
          minPrice.toString()
        );
      } else if (filteredResult?.priceText?.includes("MAX_PRICE")) {
        this.priceText = filteredResult?.priceText.replace(
          "MAX_PRICE",
          maxPrice.toString()
        );
      }
      this.useAltPriceText = true;
    }
  }
}
